import {setPassiveTouchGestures} from '@polymer/polymer/lib/utils/settings.js';
import './components/ki-catchment-map/ki-catchment-map'

export { default as KiStationView } from './views/ki-station-view/ki-station-view';

setPassiveTouchGestures(true);